import { __assign } from "tslib";
import { BasePopover } from './base-popover';
import { DeprecatedBasePopover } from './deprecated-base-popover';
import { isFeatureEnabled } from '@wix/answers-experiments';
import * as React from 'react';
export var PrimaryPopover = function (props) {
    if (props.useNewBasePopover && isFeatureEnabled('ReactPopoverMigration')) {
        var baseProps = __assign(__assign({}, props), { onOuterAction: props.onOuterAction });
        return React.createElement(BasePopover, __assign({}, baseProps, { popoverType: 'primary' }), props.children);
    }
    return React.createElement(DeprecatedBasePopover, __assign({}, props, { popoverType: 'primary' }), props.children);
};
export var Popover = PrimaryPopover;
export var SecondaryPopover = function (props) {
    if (props.useNewBasePopover && isFeatureEnabled('ReactPopoverMigration')) {
        var baseProps = __assign(__assign({}, props), { onOuterAction: props.onOuterAction });
        return React.createElement(BasePopover, __assign({}, baseProps, { popoverType: 'primary' }), props.children);
    }
    return React.createElement(DeprecatedBasePopover, __assign({}, props, { popoverType: 'secondary' }), props.children);
};
var DarkPopover = function (props) {
    if (props.useNewBasePopover && isFeatureEnabled('ReactPopoverMigration')) {
        var baseProps = __assign(__assign({}, props), { onOuterAction: props.onOuterAction });
        return React.createElement(BasePopover, __assign({}, baseProps, { popoverType: 'primary' }), props.children);
    }
    return React.createElement(DeprecatedBasePopover, __assign({}, props, { popoverType: 'dark' }), props.children);
};
export var CallDevicePopover = DarkPopover;
//# sourceMappingURL=popover.js.map